<template>
  <div>
		<div class='tip'>周一至周六15:00前的订单，当天发货，15:00以后的订单次日发货，周日不发货。
		</div>
		<div class="page">
			<div class="cell cell-up">
				<div class="cell-title">订单号        
				</div>
				<div class="cell-content">{{serialNum}} 
				</div>
			</div>
				<div class="cell">
					<div class="cell-title">下单时间     
					</div>
					<div class="cell-content">{{paid_at}}       
					</div>
				</div>
				<div class="cell">
					<div class="cell-title">冲印版数        
					</div>
					<div class="cell-content">{{printQty}}版        
					</div>
				</div>
				
				<div class="cell cell-down">
					<div class="cell-title">实付金额（包邮）        
					</div>
					<div class="price price-in-cell">¥{{(price_total/100).toFixed(2)}}        
					</div>
				</div>

			<div class="cell-interval-title">快递方式
			</div>

				<div class="cell cell-up">
					<div class="cell-title">收货人姓名        
					</div>
					<div class="cell-content">{{consigneeName}}        
					</div>
				</div>
				<div class="cell">
					<div class="cell-title">联系方式       
					</div>
					<div class="cell-content">{{consigneePhone}}        
					</div>
				</div>
				<div class="cell-flex cell-down">
					<div class="flex-title">收货地址        
					</div>
					<div class="flex-content">{{consigneeAddr}}        
					</div>
				</div>

			<div class="cell-interval-title">物流信息
				
			</div>
			<div class="cell cell-up">
				<div class="cell-title">订单状态     
				</div>
				<div class="cell-content">{{expressStatus}}      
				</div>
			</div>
			<div class="cell">
					<div class="cell-title">配送方式        
					</div>
					<div class="cell-content">{{delivery=='urgent'?'加急快递':'普通快递'}}        
					</div>
				</div>
			<div class="cell">
				<div class="cell-title">快递公司     
				</div>
				<div class="cell-content">{{expressCompany}}      
				</div>
			</div>
			<div class="cell cell-down">
				<div class="cell-title">快递单号     
				</div>
				<div class="cell-content">{{expressNumber}}      
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serialNum: null,
      consigneeName: null,
      consigneePhone: null,
      consigneeAddr: null,
      expressStatus: null,
      expressCompany: null,
      expressNumber: null,
      printQty: null,
			delivery:null,
			paid_at:null,
			price_total:null
    };
  },
  created() {
    const {
    	final_pic_name,
    	photoUrl,
      serialNum,
      consigneeName,
      consigneePhone,
      consigneeAddr,
      expressStatus,
      expressCompany,
      expressNumber,
      printQty,
			delivery,
			paid_at,
			price_total
    } = this.$route.query;
    this.final_pic_name=final_pic_name;
		this.photoUrl=photoUrl;
    this.serialNum = serialNum;
    this.consigneeName = consigneeName;
    this.consigneePhone = consigneePhone;
    this.consigneeAddr = consigneeAddr;
    this.expressStatus = expressStatus;
    this.expressCompany = expressCompany;
    this.expressNumber = expressNumber;
    this.printQty = printQty;
		this.delivery=delivery;
		this.paid_at=paid_at;
		this.price_total=price_total;
		this.$ba.trackPageview('detailPrintOrder');
  }
};
</script>

<style lang="scss" scoped>
.page{
  padding: 60px 10px 0 10px;
}

.cell-interval-title{
  padding-left: 15px;
  height: 32px;
  line-height: 42px;
  font-size: 12px;
  color: #999999;
}
.cell-flex{
  width:94.667vw;
  height:auto;
  background:rgba(255,255,255,1);
  padding: 17.5px 17px;
  display: flex;
  flex-direction: row;
  align-content: center;
}
.flex-title{
  display: inline-block;
  color: #666666;
  font-size: 14px;
  width: 17.33vw;
}
.flex-content{
  text-align: right;
  width:69.333vw;
  font-size: 14px;
}
.tip{
  position: fixed;
  top: 0;
  width:100vw;
  height:60px;
  background:rgba(255,249,240,1);
  color:rgba(245,166,35,1);
  font-size:13px;
  padding:10px 11px 14px 0.533vw;
}
</style>
